module.exports = __webpack_public_path__ + "static/design06-4c4294a3074ec855b70c64f5f5f27522.png";